import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { 
  CustomerService01Icon, 
  SentIcon,
  ArrowLeft01Icon
} from '@hugeicons/core-free-icons';
import Button from '../components/Button';

const SupportCompose = () => {
  const navigate = useNavigate();

  const handleSendEmail = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const subject = formData.get('subject');
    const body = formData.get('body');
    
    // Construct mailto link
    const mailtoLink = `mailto:support@safzi.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Trigger navigation
    window.location.href = mailtoLink;
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <button 
        onClick={() => navigate('/support')}
        className="flex items-center text-muted-gray hover:text-charcoal dark:hover:text-white font-bold transition-colors"
      >
        <HugeiconsIcon icon={ArrowLeft01Icon} size={20} className="mr-2" />
        Back to Support
      </button>

      <div className="bg-white/80 dark:bg-dark-surface/80 backdrop-blur-md p-8 rounded-[2.5rem] border border-light-gray/20 dark:border-dark-border/20 shadow-float-lg animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="flex items-center gap-4 mb-8">
          <div className="bg-purple-500/10 p-4 rounded-3xl text-purple-500">
            <HugeiconsIcon icon={CustomerService01Icon} size={32} />
          </div>
          <div>
            <h1 className="text-3xl font-black text-charcoal dark:text-white tracking-tight">Compose Message</h1>
            <p className="text-muted-gray mt-1 font-medium">We usually reply within 24 hours.</p>
          </div>
        </div>
        
        <form onSubmit={handleSendEmail} className="space-y-6">
          <div>
            <label className="block text-xs font-black text-muted-gray uppercase tracking-widest mb-2 px-1">Subject</label>
            <input 
              name="subject"
              required
              placeholder="Brief summary of your issue"
              className="w-full px-6 py-4 bg-off-white/50 dark:bg-gray-800/50 border border-light-gray/20 dark:border-gray-700/20 rounded-2xl focus:ring-2 focus:ring-soft-green outline-none font-bold text-charcoal dark:text-white transition-all"
            />
          </div>
          
          <div>
            <label className="block text-xs font-black text-muted-gray uppercase tracking-widest mb-2 px-1">Message Body</label>
            <textarea 
              name="body"
              required
              rows="8"
              placeholder="Please describe your issue in detail..."
              className="w-full px-6 py-4 bg-off-white/50 dark:bg-gray-800/50 border border-light-gray/20 dark:border-gray-700/20 rounded-2xl focus:ring-2 focus:ring-soft-green outline-none font-medium text-charcoal dark:text-white resize-none transition-all"
            />
          </div>

          <div className="pt-2">
            <Button type="submit" className="w-full py-4 rounded-2xl font-black gap-2 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all">
              <HugeiconsIcon icon={SentIcon} size={20} />
              Open Email Client
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupportCompose;
